/* tslint:disable */
/* eslint-disable */
/**
 * timereport-service
 * timereport-service
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const TimereportStatus = {
    Blank: 'Blank',
    Draft: 'Draft',
    SubmittedByConsultant: 'SubmittedByConsultant',
    SentToConsultant: 'SentToConsultant',
    SentToCustomer: 'SentToCustomer',
    ApprovedByCustomer: 'ApprovedByCustomer',
    RejectedByCustomer: 'RejectedByCustomer',
    ConsultantPaymentProcessed: 'ConsultantPaymentProcessed',
    Canceled: 'Canceled',
    Disabled: 'Disabled'
} as const;

export type TimereportStatus = typeof TimereportStatus[keyof typeof TimereportStatus];



